import { render, staticRenderFns } from "./PenChartDetail.vue?vue&type=template&id=ecb3b36e&scoped=true&"
import script from "./PenChartDetail.vue?vue&type=script&lang=js&"
export * from "./PenChartDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/page/patientAgreeDetail.css?vue&type=style&index=0&id=ecb3b36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb3b36e",
  null
  
)

export default component.exports